import { AxiosClient } from "redux/AxiosClient";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addMasterCurriculumAsync = createAsyncThunk(
  "admin/addMasterCurriculum",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addMasterCurriculum`, payload, toolkit);
  }
);

export const getAllMasterCurriculumAsync = createAsyncThunk(
  "admin/getAllMasterCurriculum",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllMasterCurriculum?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}&status=${payload.status || ""}`,
      [],
      toolkit
    );
  }
);

export const getMasterCurriculumByIdAsync = createAsyncThunk(
  "admin/getMasterCurriculum",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getMasterCurriculum/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateMasterCurriculumByIdAsync = createAsyncThunk(
  "admin/updateMasterCurriculumById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateMasterCurriculumById`,
      payload,
      toolkit
    );
  }
);

export const updateMasterCurriculumStatusAsync = createAsyncThunk(
  "admin/updateMasterCurriculumStatus",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateMasterCurriculumStatus`,
      payload,
      toolkit
    );
  }
);
